import intitle from "./module/intitle/index";
import questionnaire from "./module/questionnaire/index";
import establish from "./module/establish/index";
import upload from "./module/upload/index";
import affirm from "./module/affirm";
import details from "./module/details";
import quotation from "./module/quotation";

export default {
  zh: {
    intitle: intitle.zh,
    questionnaire: questionnaire.zh,
    establish: establish.zh,
    upload: upload.zh,
    affirm: affirm.zh,
    details: details.zh,
    quotation: quotation.zh,
  },
  en: {
    intitle: intitle.en,
    questionnaire: questionnaire.en,
    establish: establish.en,
    upload: upload.en,
    affirm: affirm.en,
    details: details.en,
    quotation: quotation.en,
  },
};
